var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 91,
    viewBox: "0 0 79 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6554_16723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.932 42.88H54.9584H54.932ZM82.6299 16H82.6562H82.6299ZM82.6299 48H82.6562H82.6299ZM71.4188 21.12C71.4188 21.12 71.4188 34.56 60.2078 34.56C71.4188 34.56 71.4188 48 71.4188 48C71.4188 48 71.4188 34.56 82.6299 34.56C71.4188 34.56 71.4188 21.12 71.4188 21.12ZM55.5915 16C55.5915 16 55.5915 21.76 49.6562 21.76C55.5915 21.76 55.5915 27.52 55.5915 27.52C55.5915 27.52 55.5915 21.76 61.5268 21.76C55.5915 21.76 55.5915 16 55.5915 16Z",
    fill: "url(#paint0_radial_6554_16723)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6554_16723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1199 38.0859H26.8801C23.6563 38.0859 21.043 40.6993 21.043 43.923V71.1628C21.043 74.3866 23.6563 76.9999 26.8801 76.9999H54.1199C57.3436 76.9999 59.9569 74.3866 59.9569 71.1628V43.923C59.9569 40.6993 57.3436 38.0859 54.1199 38.0859Z",
    fill: "url(#paint1_radial_6554_16723)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6484 67.0645C16.1333 67.0645 14.6802 66.4625 13.6088 65.3914C12.5374 64.32 11.9355 62.8667 11.9355 61.3516V34.6914C11.9355 33.1763 12.5374 31.7232 13.6088 30.6518C14.6802 29.5804 16.1333 28.9785 17.6484 28.9785H44.3087C45.8238 28.9785 47.277 29.5804 48.3484 30.6518C49.4196 31.7232 50.0216 33.1763 50.0216 34.6914",
    stroke: "#D9E3F9",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8371 57.9569C6.289 57.9569 4.80431 57.3419 3.70964 56.2474C2.61499 55.1527 2 53.6679 2 52.1199V24.8801C2 23.332 2.61499 21.8473 3.70964 20.7526C4.80431 19.658 6.289 19.043 7.8371 19.043H35.0769C36.6249 19.043 38.1097 19.658 39.2044 20.7526C40.2989 21.8473 40.914 23.332 40.914 24.8801",
    stroke: "#D9E3F9",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6554_16723",
    x: 39.6562,
    y: 10,
    width: 53,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6554_16723"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6554_16723",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6554_16723",
    x: 11.043,
    y: 32.0859,
    width: 58.9141,
    height: 58.9141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6554_16723"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6554_16723",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6554_16723",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9255 64) rotate(-85.5111) scale(158.927 184.243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B02C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6554_16723",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5397 96.4569) rotate(-85.6466) scale(193.229 217.301)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B02C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersMagic);
export default __webpack_public_path__ + "static/media/layers-magic.d8ef3120f4d024495df4bcf2e1e8b2f8.svg";
export { ForwardRef as ReactComponent };